import React, { useState, useEffect } from 'react';
import styles from './CookieNew.module.scss';

export default function CookieNew({ fields }) {
  const [getItemContentIndex, setGetItemContentIndex] = useState(0);

  const handleBrandSelect = () => {
    setGetItemContentIndex(1);
    sessionStorage.cookieNumLs = 'accept';
  };

  const acceptInit = () => {
    if (getItemContentIndex === 0 && sessionStorage.cookieNumLs === 'accept') {
      setGetItemContentIndex(1);
    }
  };

  acceptInit();

  return (
    <div className={`${styles.CookieNewComp} ${getItemContentIndex ? styles.disabled : ''}`}>
      <div className={styles.CookieNewIn}>
        <section
          className={styles.CookieNewArticle}
          dangerouslySetInnerHTML={{ __html: fields.content?.value }}
        ></section>

        <section className={styles.CookieNewBottonLine}>
          <span className={styles.CookieNewBottonLine__button} onClick={() => handleBrandSelect()}>
            {fields.buttonText?.value || 'Accept'}
          </span>
        </section>
      </div>
    </div>
  );
}
